import type { OverlayScrollbarsComponent } from 'overlayscrollbars-react'
import React from 'react'

import { LayoutScroll } from 'components/LayoutPage'

import * as s from './Modal.module.scss'

interface IModalBodyProps {
  children: React.ReactNode
  autoUpdateInterval?: number
  autoUpdate?: boolean
  sizeAutoCapable?: boolean
  scrollRef?: React.Ref<OverlayScrollbarsComponent>
}

const ModalBody = React.forwardRef<HTMLDivElement, IModalBodyProps>(
  ({ children, autoUpdateInterval, autoUpdate, sizeAutoCapable, scrollRef, ...rest }, ref) => (
    <LayoutScroll
      autoUpdate={autoUpdate}
      autoUpdateInterval={autoUpdateInterval}
      sizeAutoCapable={sizeAutoCapable}
      showBorder
      {...rest}
      ref={scrollRef}
    >
      <div className={s.body} ref={ref}>
        {children}
      </div>
    </LayoutScroll>
  ),
)

ModalBody.displayName = 'ModalBody'

export default ModalBody
